export default {
    network: {
        connectedToInternet: 'Make sure you are connected to the Internet.',
        connectionRetrieved: 'Connection with server retrieved.',
        unableToConnect: 'Unable to connect to server.',
    },
    general: {
        actions: 'Actions',
        add: 'Add',
        allTab: 'All',
        back: 'Back',
        btnRefresh: 'Refresh now',
        bulkAction: 'Bulk Action',
        bulkActions: 'Bulk Actions',
        cancel: 'Cancel',
        clickHere: 'Click here',
        close: 'Close',
        comingSoon: 'Coming soon...',
        create: 'Create',
        delete: 'Delete',
        download: 'Download',
        edit: 'Edit',
        email: 'Email',
        error: 'Error',
        export: 'Export',
        help: 'Help',
        import: 'Import',
        loading: 'Loading',
        logout: 'Logout',
        next: 'Next',
        none: 'None',
        noResults: 'No results.',
        notSent: 'Not sent',
        patience: "It's almost done. I swear.",
        previous: 'Previous',
        remove: 'Remove',
        save: 'Save',
        search: 'Search...',
        select: 'Select...',
        send: 'Send',
        sent: 'Sent',
        settings: 'Settings',
        sms: 'SMS',
        success: 'Success',
        upload: 'Upload',
        warning: 'Warning',
    },
    confirmModal: {
        yes: 'Yes',
        no: 'No',
    },
    mainNav: {
        appointments: 'Appointments',
        automations: 'Automations',
        campaigns: 'Campaigns',
        chat: 'Chat',
        contacts: 'Contacts',
        imports: 'Imports History',
        payments: 'Payments',
        accounts: 'Accounts',
        importResult: 'Import Result',
        tooltips: {
            comingSoon: 'Coming soon',
        },
        support: 'Contact support',
    },
    maintenance: 'Maintenance in progress. Be right back.',
    date: {
        today: 'Today',
        yesterday: 'Yesterday',
    },
    errors: {
        notFound: {
            title: 'Error. Page not found.',
            description: 'The page you\'re looking for does not exist.',
            button: 'Get me out of here!',
        },
        unknown: 'An unknown error occurred. Please try again.',
        validationError: 'A validation error occurred.',
        validationErrorTitle: 'Validation Error',
    },
    notifications: {
        newMessage: 'New message',
        paymentReceivedTitle: 'Payment received',
        paymentReceivedBody: '{contact} has made a payment. | {contact} has paid invoice #{number}.',
    },
    weekdays: {
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        sunday: 'Sunday',
    },
    phoneStatus: {
        valid: 'Valid',
        notValidated: 'Not validated',
        invalid: 'Invalid',
    },
    civility: {
        mr: 'Mr.',
        ms: 'Ms.',
        miss: 'Miss',
        dr: 'Dr',
        esq: 'Esq.',
    },
    pagination: {
        results: 'Results {start}-{end} of {total}',
    },
    trial: {
        smsLimitExceeded: 'The account monthly SMS limit has been reached.',
    },
    countries: {
        ca: 'Canada',
        us: 'United States',
    },
    provinces: {
        ab: 'Alberta',
        bc: 'British Columbia',
        mb: 'Manitoba',
        nb: 'New Brunswick',
        nl: 'Newfoundland and Labrador',
        ns: 'Northwest Territories',
        nt: 'Nova Scotia',
        nu: 'Nunavut',
        on: 'Ontario',
        pe: 'Prince Edward Island',
        qc: 'Quebec',
        sk: 'Saskatchewan',
        yt: 'Yukon',
    },
    states: {
        al: 'Alabama',
        ak: 'Alaska',
        az: 'Arizona',
        ar: 'Arkansas',
        ca: 'California',
        co: 'Colorado',
        ct: 'Connecticut',
        de: 'Delaware',
        fl: 'Florida',
        ga: 'Georgia',
        hi: 'Hawaii',
        id: 'Idaho',
        il: 'Illinois',
        in: 'Indiana',
        ia: 'Iowa',
        ks: 'Kansas',
        ky: 'Kentucky',
        la: 'Louisiana',
        me: 'Maine',
        md: 'Maryland',
        ma: 'Massachusetts',
        mi: 'Michigan',
        mn: 'Minnesota',
        ms: 'Mississippi',
        mo: 'Missouri',
        mt: 'Montana',
        ne: 'Nebraska',
        nv: 'Nevada',
        nh: 'New Hampshire',
        nj: 'New Jersey',
        nm: 'New Mexico',
        ny: 'New York',
        nc: 'North Carolina',
        nd: 'North Dakota',
        oh: 'Ohio',
        ok: 'Oklahoma',
        or: 'Oregon',
        pa: 'Pennsylvania',
        ri: 'Rhode Island',
        sc: 'South Carolina',
        sd: 'South Dakota',
        tn: 'Tennessee',
        tx: 'Texas',
        ut: 'Utah',
        vt: 'Vermont',
        va: 'Virginia',
        wa: 'Washington',
        wv: 'West Virginia',
        wi: 'Wisconsin',
        wy: 'Wyoming',
    },
    disabled: {
        missingValidProviderPhoneTooltip: 'You must have a valid provider phone to perform this action',
    },
};
